<template>
  <div class="product_categray">
    <div class="categray_wrap">
      <ul class="flex categray_ul" :class="briefStatus?'briefflex':''" :style="[{marginLeft: cateLeft+'px'}]">
        <li v-for="(item, index) in briefList" :key="index">
            <div class="trademark_menu">
              <div class="trademark_smallimg">
                <el-image
                   style="width: 254px; height: 290px"
                   :src="item.picUrl"
                   :preview-src-list="srcList">
                </el-image>
              </div>

              <img class="trademark_img" @click="picUrlclick(item.picUrl)" :src="item.picUrl" />
              <div class="trademark_name gobyndsingle">{{item.infoName}}</div>
            </div>
        </li>
      </ul>
    </div>
    <template v-if="briefList.length>4">
      <div class="categray_arrow categray_arrow_left flexcenter flexcolumn">
        <img src="../../assets/image/arrow_left.png" @click="fnPrev()" />
      </div>
      <div class="categray_arrow categray_arrow_right flexcenter flexcolumn">
        <img src="../../assets/image/arrow_right.png" @click="fnNext()" />
      </div>
    </template>
    <van-popup v-model="showBigimg">
      <img class="phoneimg" :src="urlBigimg" />
    </van-popup>
  </div>
</template>

<script>
  export default {
      props:{
        briefList: {
          type: Array,
          default: []
        },
      },
      data() {
        return {
          bathUrl: 'https://mall.alicdn.girdeargroup.com/admin/pms/media/images/',
          cateLeft: 0,
          cateTotalwidth: 0,
          windowWidth: 1200,
          briefStatus: false,
          showBigimg: false,
          urlBigimg: '',
          srcList: [],
        };
      },

      created() {
        if(this.briefList.length<4){
          this.briefStatus = true;
        }
        this.briefList.forEach((item)=>{
          this.srcList.push(item.picUrl)
        })
      },
      mounted(){
        this.windowWidth = document.documentElement.clientWidth;
        window.addEventListener('resize', () => { //监听浏览器窗口大小改变
                //浏览器变化执行动作
          this.windowWidth = window.innerWidth
        });
      },
      methods:{
        picUrlclick(url){
          window.open(url, "_blank");
          // this.urlBigimg = url;
          // this.showBigimg = true;
        },
        fnPrev(){
          if(this.windowWidth>480){
            if(this.cateLeft>= -264){
              this.cateLeft = 0;
              this.cateTotalwidth = 0;
            }else{
              this.cateLeft = this.cateLeft + 264;
            }
          }else{
            if(this.cateLeft>= -163){
              this.cateLeft = 0;
              this.cateTotalwidth = 0;
            }else{
              this.cateLeft = this.cateLeft + 163;
            }
          }
        },
        fnNext(){
          console.log('this.windowWidth', this.windowWidth)
          if(this.windowWidth>480){
            let mylength = this.briefList.length - 4;
            if(this.cateTotalwidth<mylength){
              this.cateTotalwidth +=1;
              this.cateLeft = this.cateLeft-264;
            }
          }else{
            let mylength = this.briefList.length - 2;
            if(this.cateTotalwidth<mylength){
              this.cateTotalwidth +=1;
              this.cateLeft = this.cateLeft-163;
            }
          }
        },
      }
  }
</script>

<style scoped lang="less">
  @media screen and (max-width: 480px){
    .phoneimg{width: 400px;}
    .product_categray{
      height: 180px;
      .categray_arrow{
        width: 20px;height: 100%;background-color: #FFFFFF;position: absolute;
        img{width: 8px;height: 15px;cursor: pointer;}
      }
      .categray_arrow_left{left: 0;}
      .categray_arrow_right{right: 0;}
      .categray_wrap{
        overflow-x: scroll;
        white-space: nowrap;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        margin: 0 auto;
        .categray_ul{
          transition: 0.3s;
          li{
            cursor: pointer;
            display: block;
            margin: 0 5px;
            .trademark_menu{
              width: 150px;
              text-align: center;

            }
            .trademark_smallimg{display: none;}
            .trademark_img{
              width: 150px;
              height: 180px;
            }
            .trademark_name{
              font-weight: bold;
              display: none;
            }
          }
        }
      }
    }
    .categray_wrap{width: 319px;}
  }
  @media screen and (min-width: 481px){
    .briefflex{justify-content: center;}
    .product_categray{
      height: 337px;
    }
    .categray_wrap{width: 1056px;}
    .categray_arrow{
      width: 36px;height: 100%;background-color: #FFFFFF;position: absolute;
      img{width: 27px;height: 50px;cursor: pointer;}
    }
    .categray_arrow_left{left: 0;}
    .categray_arrow_right{right: 0;}
    .categray_wrap{
      overflow-x: scroll;
      white-space: nowrap;
      position: absolute;
      padding-bottom: 10px;
      left: 72px;
      top: 0;
      .categray_ul{
        transition: 0.3s;
        li{
          cursor: pointer;
          display: block;
          line-height: 40px;
          border-radius: 20px;
          margin: 0 5px;
          .trademark_menu{
            width: 254px;
            text-align: center;
            .trademark_img{
              width: 254px;
              height: 290px;
              display: none;
            }
            .trademark_name{
				width: 254px;
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .product_categray{
    width: 100%;
    overflow-y: hidden;
    font-size: 18px;
    text-align: center;
    position: relative;

  }
</style>
